<template>
    <v-card class="flat-border-card form" flat>
		<v-card-title>
			<h3 class="headline mb-0">{{ title }}</h3>
		</v-card-title>
		<v-card-text>
			<slot></slot>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>